(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // Desktop only; keep in sync with the media query in scroll-reveal.css.
  if (!window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  // Whole sections fade in as one block; their contents never animate on their own.
  var SELECTOR = 'main#MainContent > .shopify-section, footer .shopify-section';

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var section = entry.target;
        observer.unobserve(section);
        section.classList.add('is-revealed');
        section.addEventListener('transitionend', function done(event) {
          if (event.target !== section) return;
          section.removeEventListener('transitionend', done);
          section.classList.remove('reveal-pending', 'is-revealed');
        });
      });
    },
    // No ratio threshold: a section much taller than the screen could never reach one and would stay hidden.
    { threshold: 0, rootMargin: '0px 0px -5% 0px' }
  );

  function setup() {
    document.querySelectorAll(SELECTOR).forEach(function (section) {
      if (section.dataset.revealInit) return;
      section.dataset.revealInit = 'true';

      // Sections already on screen at load stay visible, so nothing flashes.
      if (section.getBoundingClientRect().top < window.innerHeight) return;

      section.classList.add('reveal-pending');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();
